<div class="container">
  <label>{{ label }}</label>
  <ngx-file-drop (onFileDrop)="dropped($event)">
    <ng-template ngx-file-drop-content-tmp>
      <div class="file-drop-zone" (click)="fileInput.click()">
        <img src="assets/images/upload.svg" />
        <p>{{ text }}</p>
      </div>
    </ng-template>
  </ngx-file-drop>
  <input
    #fileInput
    type="file"
    [accept]="acceptedFileType"
    style="display: none"
    (change)="onFileSelected($event)"
  />
  <div *ngIf="file" class="file-info-container">
    <div class="file-info">
      <div class="file-name-icon">
        <img src="assets/images/file.svg" />
        <p>{{ file.name }}</p>
      </div>
      <button (click)="removeFile()">&#10060;</button>
    </div>
  </div>
  <div *ngFor="let historyFile of historyFiles" class="file-info-container">
    <div class="file-info">
      <p>{{ historyFile.name }}</p>
    </div>
  </div>
</div>
